import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VProgressLinear,{attrs:{"color":"green","height":"15","value":_vm.getProgress,"striped":""}},[_c('strong',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm.$t('delivery.states.'+_vm.order.state)))])])}
var staticRenderFns = []

export { render, staticRenderFns }